import { format } from 'date-fns';
import * as yup from 'yup';

export const dateFilterBarSchema = (t: any, minStartDate: Date, maxEndDate: Date): yup.AnyObjectSchema =>
  yup.object().shape({
    startDate: yup
      .date()
      .nullable()
      .typeError(t('dateFilterBar.validation.time.invalid'))
      .max(new Date(), t('dateFilterBar.validation.futureError'))
      .min(minStartDate, t('dateFilterBar.validation.minDate', { minDate: format(minStartDate, 'dd/MM/y') })),
    endDate: yup
      .date()
      .nullable()
      .typeError(t('dateFilterBar.validation.time.invalid'))
      .max(new Date(), t('dateFilterBar.validation.futureError'))
      .max(maxEndDate, t('dateFilterBar.validation.maxDate', { maxDate: format(maxEndDate, 'dd/MM/y') }))
      .min(yup.ref('startDate'), t('dateFilterBar.validation.endDateBeforeStart')),
  });
